var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"editor-3975"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editorContent),expression:"editorContent"}],ref:"editor",attrs:{"id":"editor"},domProps:{"value":(_vm.editorContent)},on:{"input":function($event){if($event.target.composing)return;_vm.editorContent=$event.target.value}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }